<!-- Estado: nenhum arquivo selecionado -->
@if (nomeArquivo === '' && !processandoDados) {
  <div class="upload-content">
    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_upload)">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M20.5 5.83329C25.6547 5.83329 29.8333 10.012 29.8333 15.1666C29.8333 18.6196 27.9589 21.6364 25.1657 23.2521C24.5283 23.6209 24.3105 24.4365 24.6792 25.0739C25.0479 25.7113 25.8636 25.9291 26.501 25.5604C30.0843 23.4876 32.5 19.61 32.5 15.1666C32.5 8.53921 27.1274 3.16663 20.5 3.16663C15.2635 3.16663 10.8129 6.51965 9.17336 11.1946C8.95117 11.1761 8.72659 11.1666 8.5 11.1666C4.08172 11.1666 0.5 14.7483 0.5 19.1666C0.5 23.0385 3.24928 26.2653 6.90142 27.0066C7.62309 27.1531 8.32686 26.6868 8.47335 25.9652C8.61984 25.2435 8.15357 24.5397 7.43191 24.3933C4.99808 23.8992 3.16667 21.7453 3.16667 19.1666C3.16667 16.2211 5.55448 13.8333 8.5 13.8333C8.94909 13.8333 9.38343 13.8885 9.79736 13.9919L11.1067 14.3188L11.4178 13.0056C12.3923 8.8924 16.0905 5.83329 20.5 5.83329Z"
          fill="#008060"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M11.5572 22.7761C11.0365 22.2554 11.0365 21.4112 11.5572 20.8905L15.5572 16.8905C16.0779 16.3698 16.9221 16.3698 17.4428 16.8905L21.4428 20.8905C21.9635 21.4112 21.9635 22.2554 21.4428 22.7761C20.9221 23.2968 20.0779 23.2968 19.5572 22.7761L16.5 19.7189L13.4428 22.7761C12.9221 23.2968 12.0779 23.2968 11.5572 22.7761Z"
          fill="#008060"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M16.5 29.8334C15.7636 29.8334 15.1667 29.2364 15.1667 28.5L15.1667 17.8334C15.1667 17.097 15.7636 16.5 16.5 16.5C17.2364 16.5 17.8333 17.097 17.8333 17.8334L17.8333 28.5C17.8333 29.2364 17.2364 29.8334 16.5 29.8334Z"
          fill="#008060"/>
      </g>
      <defs>
        <clipPath id="clip0_upload">
          <rect width="32" height="32" fill="white" transform="translate(0.5 0.5)"/>
        </clipPath>
      </defs>
    </svg>
    <p class="mensagem-arquivo">
      Arraste ou selecione seu arquivo<br>
      <strong>{{listaExtensoes}} até 10MB</strong>
    </p>
  </div>
  <input class="input-arquivo" id="file" type="file" accept="{{listaExtensoes}}"
    (change)="arquivoCapturado.emit($event)">
}

<!-- Estado: arquivo selecionado -->
@if (nomeArquivo !== '' && !processandoDados) {
  <div class="upload-content">
    <svg width="25" height="31" viewBox="0 0 25 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M3.16667 6.16671C3.16667 4.69395 4.36057 3.50004 5.83333 3.50004H12.5V7.50004C12.5 10.4456 14.8878 12.8334 17.8333 12.8334H21.8333V24.8334C21.8333 26.3061 20.6394 27.5 19.1667 27.5H5.83333C4.36057 27.5 3.16667 26.3061 3.16667 24.8334V6.16671ZM21.7895 10.1667C21.6817 9.57973 21.3788 9.0407 20.9227 8.64157L15.8007 4.15984C15.6085 3.99168 15.3948 3.85336 15.1667 3.74756V7.50004C15.1667 8.9728 16.3606 10.1667 17.8333 10.1667H21.7895ZM5.83333 0.833374C2.88782 0.833374 0.5 3.22119 0.5 6.16671V24.8334C0.5 27.7789 2.88781 30.1667 5.83333 30.1667H19.1667C22.1122 30.1667 24.5 27.7789 24.5 24.8334V10.6484C24.5 9.11051 23.8361 7.64744 22.6787 6.6347L17.5567 2.15297C16.5845 1.30227 15.3365 0.833374 14.0447 0.833374H5.83333Z"
        fill="#008060"/>
    </svg>
    <p class="mensagem-arquivo-selecionado">
      {{nomeArquivo}}<br>
      <span class="mensagem-arquivo"><strong>Adicionado em {{dataHoje | date: 'dd/MM/yy'}}</strong></span>
    </p>
    <button class="btn-icon" aria-label="Limpar arquivo selecionado" (click)="arquivoLimpo.emit()">
      <i class="fa fa-times ci-gray" aria-hidden="true"></i>
    </button>
  </div>
}

<!-- Estado: processando -->
@if (processandoDados) {
  <div class="upload-content" style="flex-direction: column; width: 100%;">
    <mat-progress-bar class="progress-bar" [mode]="'indeterminate'"></mat-progress-bar>
    <span class="subtitulo-barra-dados">Carregando...</span>
  </div>
}
